import { springMoneyUrl } from "../../utility/WebService";

// Api endpoints :-
const SpringMoneyApiEndPoints = {
  initiateSingleTransaction: `${springMoneyUrl}/shares/smallcase/transactions`,
  initiateBulkTransaction: `${springMoneyUrl}/shares/smallcase/transactions/bulk`,
  authIdAgainstInvestorId: `${springMoneyUrl}/shares/smallcase/auth/smallcase-auth-token?investor_id=`,
  // fetchTransactionId : `${springMoneyUrl}/transactions?investor_id=`,
  fetchTransactionIdByCustomerAdviceDetailsId: `${springMoneyUrl}/shares/smallcase/transactions/get-transaction?advice_details_id=`,
  userVerificationApi: `${springMoneyUrl}/shares/smallcase/transactions/user-verification`,
  fetchTransactionIdBySpTransactionId: `${springMoneyUrl}/shares/smallcase/transactions/init`,
  getBrokerList: `${springMoneyUrl}/shares/smallcase/transactions/get-brokers/`,
};

export default SpringMoneyApiEndPoints;
